<div class="banner-container">
  <div class="banner-overlay"></div>
  <img src="assets/snp Image/snp_cover_pic.png" class="banner-image" alt="Banner Image">



  <div class="compact-form">
    <form [formGroup]="compactForm" (ngSubmit)="onSubmit()">
      <h2>Contact Us</h2>
      <input formControlName="full_name" type="text" placeholder="Name" required>
      <input formControlName="phone" type="tel" placeholder="Phone" required>
      <input formControlName="email" type="email" placeholder="Email" required>


      <input formControlName="appointment_date" id="appointmentDate" type="datetime-local" required />
      <div *ngIf="compactForm.get('appointment_date')?.invalid && compactForm.get('appointment_date')?.touched"
        class="error">
        Appointment date and time are required.
      </div>
      <textarea formControlName="enq_detail_msg" placeholder="Message" required></textarea>
      <button type="submit">Submit</button>
    </form>


    <div *ngIf="isFormSubmitted" class="thank-you-message animated">
      <h3>
        Thank you for your enquiry! We will get back to you shortly!
        <span class="smiley"></span>
      </h3>
    </div>
  </div>

</div>

<div class="wrapper">
  <div class="button" *ngFor="let platform of socialMedia">
    <a [href]="platform.url" target="_blank">
      <div class="icon">
        <i [class]="platform.iconClass"></i>
      </div>
      <span>{{ platform.name }}</span>
    </a>
  </div>
</div>
